import { RtmApi } from "@/api";

export async function getSbus(options) {
  const { data } = await RtmApi.getSbus(options);
  return data;
}
